import React from "react";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";
import { POSTS } from "@/data/site";
import { SEO } from "@/data/seo";
import { useLang } from "@/context/LanguageContext";

const Actualidad = () => {
  const { t } = useLang();
  const [feature, ...rest] = POSTS;
  const fmtDate = (d) => (typeof d === "string" ? d : t(d));

  return (
    <div data-testid="actualidad-page" className="pt-[72px]">
      <Seo {...SEO.actualidad} />
      <section className="max-w-7xl mx-auto px-6 pt-20 md:pt-28">
        <Reveal>
          <span className="font-display text-xs font-bold uppercase tracking-[0.3em] text-brand-gold">{t({ es: "Actualidad", en: "News" })}</span>
          <h1 className="mt-6 font-display text-5xl md:text-7xl font-black text-white leading-none">
            {t({ es: "La agencia, hoy", en: "The agency, today" })}
          </h1>
        </Reveal>
      </section>

      {/* Featured post */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <Reveal>
          <article className="grid md:grid-cols-2 gap-10 items-center" data-testid={`post-${feature.slug}`}>
            <div className="rounded-2xl overflow-hidden aspect-[16/10]">
              <img src={feature.image} alt={t(feature.title)} className="w-full h-full object-cover" />
            </div>
            <div>
              <p className="font-display text-xs font-bold uppercase tracking-widest text-brand-gold">{fmtDate(feature.date)}</p>
              <h2 className="mt-4 font-display text-3xl md:text-4xl font-black text-white leading-tight">{t(feature.title)}</h2>
              <p className="mt-4 text-white/40 font-body text-sm">{feature.tag}</p>
            </div>
          </article>
        </Reveal>
      </section>

      {/* Rest */}
      <section className="max-w-7xl mx-auto px-6 pb-24 md:pb-32">
        <div className="grid md:grid-cols-2 gap-10 border-t border-white/10 pt-16">
          {rest.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.1}>
              <article className="group" data-testid={`post-${post.slug}`}>
                <div className="rounded-2xl overflow-hidden aspect-[16/9] mb-5">
                  <img src={post.image} alt={t(post.title)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <p className="font-display text-xs font-bold uppercase tracking-widest text-brand-gold mb-3">{fmtDate(post.date)}</p>
                <h3 className="font-display text-2xl font-bold text-white leading-snug">{t(post.title)}</h3>
                <p className="mt-3 text-white/40 text-sm font-body">{post.tag}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Actualidad;
